import { h } from "../../core/dom.js";
import { copy } from "../../config/copy.js";

export function modelStatusChip(store) {
  const chip = h("span", { class: "chip" });
  const render = ({ modelStatus, modelProgress }) => {
    const text = {
      idle: copy.modelLoading,
      loading: copy.modelLoading,
      downloading: copy.modelDownloading(modelProgress || 0),
      ready: copy.modelReady,
      missing: "Non disponibile",
      online: copy.readyOnline,
      error: "Errore"
    }[modelStatus] || copy.modelLoading;
    chip.textContent = text;
    chip.title = {
      ready: "Il modello è sul tuo telefono: l'analisi funziona anche senza connessione",
      online: "L'analisi funziona, ma serve la connessione perché il modello non è ancora sul telefono",
      downloading: "Sto scaricando il modello: succede una volta sola",
      missing: "Il modello non è ancora disponibile",
      error: "Qualcosa è andato storto nel preparare l'analisi"
    }[modelStatus] || "Preparo l'analisi";
    chip.className = `chip chip-${modelStatus}`;
  };
  render(store.state);
  store.subscribe(render);
  return chip;
}
